<template>
  <div class="map" ref="map" :style="{ width: width, height: height, display: isShowMap ? 'block' : 'none' }"></div>
</template>

<script>
export default {
  name: 'CustomMapMarker',
  props: {
    width: {
      type: String,
      default: '800px'
    },
    height: {
      type: String,
      default: '100%'
    },
    // 是否可以拖拽点
    isDrag: {
      type: Boolean,
      default: false
    },
    // 是否可以操作电子围栏
    isClickPolyon: {
      type: Boolean,
      default: true
    },
    // 详情不可移动点
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    // 是否展示地图 适用于需要搜索地址功能
    isShowMap: {
      type: Boolean,
      default: true
    },
    // 搜索地址功能
    isSearch: {
      type: Boolean,
      default: false
    },
    // mapType位置设置: topleft, topright, bottomleft, bottomright
    mapTypePosition: {
      type: String,
      default: 'topright'
    },
    zoom: {
      type: Number,
      default: 16
    }
  },
  data() {
    return {
      points: [], // 多个dian
      polygons: [],
      polygonTool: null, // 多边形工具对象
      addPolyonCode: 0,
      marker: [],
      linePoint: [],
      linesObj: []
    }
  },
  computed: {
  },
  watch: {
    value(newV, oldV) {
      const lngLat = new AMap.LngLat(+newV[0].longitude, +newV[0].latitude)
      // 编辑
      if (this.marker.length > 0) {
        this.marker[0].setPosition(lngLat)
      } else {
        this.initMarker()
      }
    }
  },
  created() {
    // do something
  },
  destroy() { },
  mounted() {
    this.$nextTick(() => {
      this.initMap()
    })
  },
  methods: {
    initMap() {
      AMap.plugin(['AMap.MapType'], () => {
        this._map = new AMap.Map(this.$refs.map)

        this._map.setZoomAndCenter(this.zoom, new AMap.LngLat(118.709695, 32.019756))
        // 地图类型控件
        const ctrl = new AMap.MapType({
          defaultType: 0, // 默认显示的地图类型
          showLabel: true, // 是否显示label
          typeList: [
            AMap.MAPTYPE_NORMAL, // 普通地图
            AMap.MAPTYPE_SATELLITE, // 卫星地图
            [AMap.MAPTYPE_SATELLITE, AMap.MAPTYPE_HYBRID] // 卫星影像 + 路网图层
          ]
        })
        this._map.addControl(ctrl)
        this.initMarker()
        // 地区搜索
        this.isSearch && this.onLoadSearch()
      })
    },
    initMarker() {
      // 初始化打点
      if (this.value && this.value.length) {
        // this._map.centerAndZoom(new AMap.LngLat(+this.value[0].longitude, +this.value[0].latitude), this.zoom)
        this._map.setZoomAndCenter(this.zoom, new AMap.LngLat(+this.value[0].longitude, +this.value[0].latitude))
        this.value.forEach(item => {
          const marker = new AMap.Marker({
            position: [+item.longitude, +item.latitude],
            draggable: this.isDrag
          })
          this._map.add(marker)
          if (!this.disabled) {
            marker.on('click', event => {
              const lngLat = new AMap.LngLat(event.lnglat.lng, event.lnglat.lat)
              marker.setPosition(lngLat)
              this.$emit('input', [{
                longitude: event.lnglat.lng,
                latitude: event.lnglat.lat
              }])
            })
          }
          this.marker.push(marker)
        })
      } else {
        if (!this.disabled) {
          // 编辑
          // this._map.addEventListener('click', event => {
          //   const lngLat = new AMap.LngLat(event.lnglat.lng, event.lnglat.lat)
          //   if (this.marker[0]) {
          //     this.marker[0].setLngLat(lngLat)
          //   } else {
          //     const marker = new AMap.Marker(lngLat)
          //     this._map.addOverLay(marker)
          //     this.marker.push(marker)
          //   }
          //   this.$emit('input', [{
          //     longitude: event.lnglat.lng,
          //     latitude: event.lnglat.lat
          //   }])
          // })
          this._map.on('click', event => {
            const lngLat = new AMap.LngLat(event.lnglat.lng, event.lnglat.lat)
            if (this.marker[0]) {
              this.marker[0].setPosition(lngLat)
            } else {
              const marker = new AMap.Marker({ position: lngLat })
              this._map.add(marker)
              this.marker.push(marker)
            }
            this.$emit('input', [{
              longitude: event.lnglat.lng,
              latitude: event.lnglat.lat
            }])
          })
        }
      }
    },
    // 点击地图新增点坐标工具
    // initMarkerTool () {
    //   this._markerTool = new AMap.MarkTool(this._map, { follow: true })
    //   this._markerTool.open()
    //   this._markerTool.addEventListener('mouseup', event => {
    //     event.currentMarker.enableDragging()
    //     this.$emit('input', [{
    //       longitude: event.currentLnglat.lng,
    //       latitude: event.currentLnglat.lat
    //     }])
    //   })
    // },
    // closeMarkerTool () {
    //   if (this._markerTool) {
    //     this._markerTool.close()
    //     this._markerTool = null
    //   }
    // },
    // 设置中心点
    setZoomAndCenter(lngLat, zoom) {
      let zoomValue = this.zoom
      if (zoom) {
        zoomValue = zoom
      }
      // this._map && this._map.centerAndZoom(new AMap.LngLat(lngLat[0], lngLat[1]), zoomValue)
      this._map.setZoomAndCenter(zoomValue, lngLat)
    },
    // 清楚默认点
    clearInitMarker() {
      this.marker.forEach((item, index) => {
        this._map.remove(item)
      })
      this.marker = []
    },
    // 创建标注工具对象
    createPolyon(config1) {
      this.polygonToolClose()
      const config = config1 || {
        showLabel: false,
        color: '#36CBCB',
        weight: 3,
        opacity: 1,
        fillColor: '#36CBCB',
        fillOpacity: 0.5
      }
      // this.polygonTool = new AMap.PolygonTool(this._map, config)
      this.polygonTool = new AMap.PolygonEditor(this._map, config)
      this.polygonTool.open()
      // this.polygonTool.addEventListener('draw', (e) => {
      //   this.drawFinish(e, config)
      // })
      this.polygonTool.on('draw', (e) => {
        this.drawFinish(e, config)
      })
    },
    // 双击保存已绘制的文件
    drawFinish(e, config) {
      // e.currentPolygon.options.code = 'noSave' + this.addPolyonCode
      const polygon = e.obj;
      polygon.options.code = 'noSave' + this.addPolyonCode;
      const area = polygon.getArea();
      this.$emit('getDistance', Number(area).toFixed(2))
      const data = polygon.getPath().map(item => {
        return {
          latitude: item.getLat().toString(),
          longitude: item.getLng().toString()
        }
      })
      // 所有的围栏数据
      this.points.push(data)
      this.polygons.push(polygon)
      // this.$emit('onSavePolyon', this.points)
      this.addPolyonCode++
      this.createPolyon(config)
    },
    // 关闭多边形绘制状态
    polygonToolClose() {
      if (this.polygonTool) {
        this.polygonTool.off('draw', this.drawFinish)
        this.polygonTool.close()
        this.polygonTool = null
      }
    },
    // 绘制所有多边形
    drawPolyons(points, obj) {
      // 重新绘制前清除所有
      const drawPolyonList = points.drawPolyonList
      this.points = this.points.concat(points.setPolyonList)
      const setting = obj || {
        color: '#36CBCB',
        weight: 4,
        opacity: 1,
        fillColor: '#36CBCB',
        fillOpacity: 0.5
      }
      const polygons = []
      let polygonsPoints = []
      this._map && drawPolyonList.forEach((item, index) => {
        const validPoints = item.map(point =>
          point instanceof AMap.LngLat ? point : new AMap.LngLat(point.lng, point.lat)
        );
        // 创建面对象
        const polygon = new AMap.Polygon({
          path: validPoints.map(point => [point.lng, point.lat]),
          ...setting,
          code: points.fenceCode[index] || '',
          bubble: true  // 冒泡事件到地图上
        })
        // 向地图上添加面
        polygons.push(polygon)
        polygonsPoints = [...polygonsPoints, ...validPoints]
        this._map && this._map.add(polygon)
      })
      // 将电子围栏放到合适位置(直接传入覆盖物数组polygons)
      this._map.setFitView(polygons,true)
      this.polygons = polygons
      // 点击电子围栏
      this.isClickPolyon && this.addPolygonClick()
    },
    // 清除所有电子围栏
    clearPolyon() {
      this.polygons.forEach((item, index) => {
        this._map.remove(item)
      })
      this.polygons = []
      this.points = []
      this.polygonToolClose()
    },
    // 添加多边形点击事件
    addPolygonClick() {
      // 移除面的点击事件，防止多次注册
      this.removePolygonClick()
      // 注册面的点击事件
      this.polygons.forEach(item => {
        item.on('click', this.polygonClick)
      })
    },
    // 多边形点击
    polygonClick(e) {
      // 当前点击的多边形
      const p = e.target
      // 其余颜色恢复正常
      if (p.getOptions().color !== '#FF402B') {
        this.polygons.forEach(item => {
          item.setOptions({
            strokeColor: p.getOptions().strokeColor,
            fillColor: p.getOptions().fillColor
          });
        })
        // 当前颜色变色
        p.setOptions({
          strokeColor: '#FF402B',
          fillColor: '#FF402B'
        });
        this.$emit('currentPolygon', p.options.code)
      }
    },
    // 移除多边形点击事件
    removePolygonClick() {
      this.polygons.forEach(item => {
        item.off('click', this.polygonClick)
      })
    },
    // 删除
    deletHasDrawPolyon(current) {
      this.polygons.forEach((item, index) => {
        if (item.options.code === current) {
          this._map.remove(item)
          // 获取位置
          this.$emit('currentDeleteArea', this.getArea(this.points[index]))
          this.polygons.splice(index, 1)
          this.points.splice(index, 1)
        }
      })
    },
    getArea(item) {
      // this.polygonTool = new AMap.PolygonTool(this._map)
      // const points = []
      // item.forEach(item1 => {
      //   points.push(new AMap.LngLat(item1.longitude, item1.latitude))
      // })
      const polygon = new AMap.Polygon({
        path: item.map(point => [point.longitude, point.latitude])
      });
      const area = polygon.getArea()
      return Number(area).toFixed(2)
    },
    // 输入框地区搜索
    onLoadSearch() {
      const config = {
        pageCapacity: 10,
        onSearchComplete: this.localSearchResult
      }
      if (this._map) {
        this.localsearch = new AMap.PlaceSearch(config);
      }
    },
    querySearch(queryString) {
      this.localsearch && this.localsearch.search(queryString)
    },
    // @@搜索词
    localSearchResult(result) {
      // 根据返回类型解析搜索结果
      let list = []
      switch (parseInt(result.getResultType())) {
        case 1:
          // 解析点数据结果
          list = result.getPois()
          break
        case 2:
          // 解析推荐城市
          list = result.getStatistics()
          break
        case 3:
          // 解析行政区划边界
          list = result.getArea()
          break
        case 4:
          // 解析建议词信息
          list = result.getSuggests()
          break
        case 5:
          // 解析公交信息
          list = result.getLineData()
          break
      }
      this.$emit('getSearchResult', list)
    },
    // 绘制线条
    createLine(obj) {
      this.lineToolClose()
      const config = obj || {
        showLabel: false,
        color: '#7D27FF'
      }
      this.lineTool = new AMap.PolylineEditor(this._map, config)
      this.lineTool.open()
      this.lineTool.on('draw', this.drawFinishLine)
    },
    // 关闭线条绘制状态
    lineToolClose() {
      if (this.lineTool) {
        this.lineTool.close()
        this.lineTool.off('draw', this.drawFinishLine)
        this.lineTool = null
      }
    },
    // 双击保存已绘制的文件
    drawFinishLine(e) {
      const polyline = e.obj;
      polyline.options.code = 'noSave' + this.addPolyonCode;
      const distance = polyline.getLength();
      this.$emit('getDistance', Number(distance).toFixed(2))
      const data = polyline.getPath().map(item => {
        return {
          latitude: item.getLat().toString(),
          longitude: item.getLng().toString()
        }
      })
      this.addPolyonCode++
      this.linePoint.push(data)
      this.linesObj.push(polyline)
    },
    getLinePoints() {
      return this.linePoint
    },
    // 清除所有的线条
    clearLine() {
      this.linesObj.forEach((item, index) => {
        this._map.remove(item)
      })
      this.linesObj = []
      this.linePoint = []
      this.lineToolClose()
    },
    // 绘制线条
    drawLines(points, obj) {
      // 重新绘制前清除所有
      this.clearLine()
      this.linesObj = []
      const drawPolyonList = points.drawPolyonList
      this.linePoint = points.setPolyonList
      const setting = obj || {
        showLabel: false,
        color: '#7D27FF'
      }
      const linesObj = []
      drawPolyonList.forEach((item, index) => {
        // 创建线对象
        const line = new AMap.Polyline({
          path: item.map(point => [point.longitude, point.latitude]),
          ...setting,
          code: points.fenceCode[index] || ''
        });
        // 向地图上添加线
        linesObj.push(line)
        this._map && this._map.add(line)
      })
      this.linesObj = linesObj
    },
    // 添加线点击事件
    addLineClick() {
      // 移除面的点击事件，防止多次注册
      this.removeLineClick()
      // 注册面的点击事件
      this.linesObj.forEach(item => {
        item.on('click', this.lineClick)
      })
    },
    // 移除线点击事件
    removeLineClick() {
      this.linesObj.forEach(item => {
        item.off('click', this.lineClick)
      })
    },
    lineClick(e) {
      // 当前点击的多边形
      const p = e.target
      // 其余颜色恢复正常
      if (p.getOptions().color !== '#FF402B') {
        this.linesObj.forEach(item => {
          item.setOptions({
            strokeColor: '#9D4DFF'
          });
        })
        // 当前颜色变色
        p.setOptions({
          strokeColor: '#FF402B'
        });
        this.$emit('currentLine', p.options.code)
      }
    },
    // 获取线条的距离
    getDistance(item) {
      const polyline = new AMap.Polyline({
        path: item.map(point => [point.longitude, point.latitude])
      });
      const distance = polyline.getLength();
      return Number(distance).toFixed(2)
    },
    // 删除
    deleteDrawLine(current) {
      this.linesObj.forEach((item, index) => {
        if (item.options.code === current) {
          this._map.remove(item)
          this.linesObj.splice(index, 1)
          // 获取经纬度
          this.$emit('currentDeleteArea', this.getDistance(this.linePoint[index]))
          this.linePoint.splice(index, 1)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.map {
  height: 100%;
  min-height: 400px;

  .map-tool {
    width: 1400px;
    height: 800px;
  }
}
#map {
  pointer-events: auto; /* 允许点击 */
  z-index: 10; /* 提高层级 */
}
</style>
